import { render, staticRenderFns } from "./PortalCard.vue?vue&type=template&id=c988cca0&scoped=true&"
import script from "./PortalCard.vue?vue&type=script&lang=js&"
export * from "./PortalCard.vue?vue&type=script&lang=js&"
import style0 from "./PortalCard.vue?vue&type=style&index=0&id=c988cca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c988cca0",
  null
  
)

export default component.exports